import React from 'react';
import { Label } from '@mentimeter/slides-presentation-ui/title/label';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { MarkdownText } from '@mentimeter/slides-presentation-ui/text/markdown-text';
import { usePresentationContext } from '../../legacy-context/presentationContext';
import { Miro } from './Miro';

export const DEFAULT_BOARD_ID = `uXjVMkSiW1M=`;
export const DEFAULT_BOARD_URL = `https://miro.com/app/board/${DEFAULT_BOARD_ID}`;

export function MiroPresentation() {
  const { useQuestion, useConfig } = usePresentationContext();

  const question = useQuestion();
  const { mode } = useConfig();
  const miroUrl = question.module_custom_data?.miro_url || DEFAULT_BOARD_URL;

  return (
    <Box width="100%" height="100%" alignItems="center" justifyContent="center">
      <Miro url={miroUrl} isScreenshotMode={mode === 'screenshot'} />
      <Box mb={4} /> {/* Spacer */}
      {question.title_meta && (
        <Label>
          <MarkdownText
            disableLineBreaks
            source={question.title_meta}
            allowHyperlinks
          />
        </Label>
      )}
      {question.question && (
        <Text
          textAlign="center"
          fontSize={8}
          fontWeight="semiBold"
          color="text"
          mb={2}
          fontFamily="heading"
          data-testid="question-title"
        >
          {question.question}
        </Text>
      )}
      {question.question_description && (
        <Text textAlign="center" fontSize={4}>
          {question.question_description}
        </Text>
      )}
    </Box>
  );
}
